var map = {
	"./Andrew Hoy.jpg": "913e",
	"./Laura Collett.jpg": "07bb",
	"./Margault Blanchard.jpg": "eb6b",
	"./Maxime Livio.jpg": "4198",
	"./Saffron Cresswell.jpg": "472f",
	"./Sam Watson.jpg": "e2e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "abe8";